<template>
<modal :no-footer="true" :size="(incomplete_address) ? 'large' : 'small'" @close="$emit('close')">
    <template slot="header">
        {{ tenant.first_name }} {{ tenant.last_name }}
        (Unit {{ tenant.unit }})
    </template>

    <template slot="content">
        <div>
            <label>Coverage</label>
            <radio-list
                :choices="coverages"
                :current-value="tenant_coverage"
                @change="(v) => $emit('updateCoverage', v)"></radio-list>
        </div>

        <div v-if="incomplete_address" class="incomplete-address-box mt-3">
            <div>
                <span class="danger-text"><i class="material-icons">announcement</i></span>
                Address is incomplete. Please fix any empty fields below.
            </div>

            <div class="mt-3">
                <label>
                    Address
                    <input type="text" v-model="tenant.address" />
                </label>
            </div>

            <div class="flex ai-c jc-sb mt-3">
                <div class="flex-33 mr-3">
                    <label>
                        City
                        <input type="text" v-model="tenant.city" />
                    </label>
                </div>

                <div class="flex-33 mr-3 ml-3">
                    <label>
                        State
                        <select-input
                            :active-index="active_state_index"
                            :choices="state_options"
                            :fixed="true"
                            @change="onChangeState"></select-input>
                    </label>
                </div>

                <div class="flex-33 ml-3">
                    <label>
                        Zip Code
                        <input type="text" v-model="tenant.zip_code" />
                    </label>
                </div>
            </div>
        </div>

        <hr />

        <div class="mt-3">
            <checkbox
                :checked="confirm_charge_applied"
                :disabled="isLoading"
                @click="confirm_charge_applied = !confirm_charge_applied">
                Confirm that insurance charge has been applied
            </checkbox>
        </div>

        <div v-if="show_insurance_effective_date" class="mt-3">
            <label for="insurance-effective-date">Insurance Effective Date</label>
            <datepicker :typeable="true" v-model="tenant.insurance_effective_date" :format="'M/dd/yyyy'" />
        </div>

        <div class="mt-3">
            <label for="note">Note</label>
            <textarea id="note" v-model="tenant.note" rows="4" />
        </div>

        <div class="flex ai-c jc-sb mt-3">
            <div>
                <span class="danger-text" v-show="errorMessage.length">{{ errorMessage }}</span>
            </div>

            <div class="flex ai-c">
                <span v-show="isLoading" class="mr-2">
                    <img src="../assets/img/loading-black-32.gif" alt="loading" />
                </span>

                <button :disabled="isLoading" type="button" @click="$emit('save', confirm_charge_applied)">Save</button>
            </div>
        </div>
    </template>
</modal>
</template>

<script>
import { statesByAbbr } from "@/utilities/states"

export default {
    name: "managers-edit-tenant-modal",

    props: ["coverages", "errorMessage", "isLoading", "tenant"],

    data () {
        return {
            active_state_index: -1,
            confirm_charge_applied: this.tenant.charge_applied_date !== null,
            incomplete_address: false,
            state_options: statesByAbbr
        }
    },

    computed: {
        /**
         * Show the insurance effective date input only if the tenant has selected coverage.
         *
         * @return {boolean}
         */
        show_insurance_effective_date () {
            if (this.tenant.coverage_id === null) {
                return false
            }

            const exclusions = ["provide_proof", "opt_out", "moved_out", "bad_address"]

            return exclusions.indexOf(this.tenant.coverage_id) === -1
        },

        tenant_coverage () {
            if (this.tenant.coverage_id === null) {
                if (this.tenant.provided_proof_date !== null) {
                    return "provide_proof"
                }

                if (this.tenant.opt_out_date !== null) {
                    return "opt_out"
                }

                if (this.tenant.move_out_date !== null) {
                    return "moved_out"
                }

                if (this.tenant.bad_address_date !== null) {
                    return "bad_address"
                }
            }

            return this.tenant.coverage_id
        }
    },

    mounted () {
        this.normalizeDates()

        // for non-coverage selected options, we need to make sure the parent sets the coverage_id
        // field initially
        this.$emit("updateCoverage", this.tenant_coverage)

        if (
            (this.tenant.address === null) ||
            (this.tenant.city === null) ||
            (this.tenant.state === null) ||
            (this.tenant.zip_code === null)
        ) {
            this.incomplete_address = true
        }

        if (this.tenant && this.tenant.state) {
            this.active_state_index = statesByAbbr.map((state) => state.key).indexOf(this.tenant.state)
        }
    },

    updated () {
        if (this.tenant.coverage_id === null) {
            if (this.tenant.provided_proof_date !== null) {
                this.tenant.coverage_id = "provide_proof"
            }

            if (this.tenant.opt_out_date !== null) {
                this.tenant.coverage_id = "opt_out"
            }

            if (this.tenant.move_out_date !== null) {
                this.tenant.coverage_id = "moved_out"
            }

            if (this.tenant.bad_address_date !== null) {
                this.tenant.coverage_id = "bad_address"
            }
        } else {
            if (this.tenant.insurance_effective_date === null) {
                this.tenant.insurance_effective_date = new Date()
            }
        }
    },

    methods: {
        /**
         * Normalize the dates because JavaScript automatically subtracts hours
         * for local time, making it appear as if the date selected is the day before.
         */
        normalizeDates () {
            if (this.tenant.insurance_effective_date) {
                const date = new Date(this.tenant.insurance_effective_date)
                date.setUTCHours(date.getHours())
                this.tenant.insurance_effective_date = date
            }
        },

        /**
         * Update the state field when a state is picked from the list.
         *
         * @param int index Chose state option index
         */
        onChangeState (index) {
            this.active_state_index = index

            this.tenant.state = this.state_options[index].key
        }
    }
}
</script>

<style scoped>
.incomplete-address-box {
    border: 1px solid #ff9b91;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ManagersEditTenantModal.vue